export { default } from "./isEventHandler.mjs";